export function canvas_links(state = [], action) {
  if (action.type === 'ADD_LINK') {
    state.push(action.link);
    return state;
  }
  return state;
}
